import React, { Component } from 'react';
import classnames from 'classnames';
import { Field } from 'redux-form';
import { Layout } from 'app/components/base/Layout';
import CheckBoxInput from 'app/components/base/CheckBoxInput';
import InteractiveInfoBlock from 'app/components/base/InteractiveInfoBlock';
import Icon from 'app/components/base/Icon';

import style from './style.css';

/**
 * An interactive info block with a checkbox
 */
class InteractiveCheckbox extends Component {
  onClickHandler = () => {
    const { onChange, value } = this.input.props;
    onChange(!value);
  };

  refCheckboxInput = (node) => {
    this.input = node;
  };

  render() {
    const { fieldName, icon, title, description, ...props } = this.props;

    return (
      <InteractiveInfoBlock {...props} onClick={this.onClickHandler}>
        <Layout align="start center" nowrap>
          <Field
            name={fieldName}
            component={CheckBoxInput}
            refInput={this.refCheckboxInput}
          />
          <Icon
            large
            family="mozio"
            name={icon}
            className={classnames(style.icon)}
          />
          <Layout direction="column">
            <span className={style.title}>{title}</span>
            <span>{description}</span>
          </Layout>
        </Layout>
      </InteractiveInfoBlock>
    );
  }
}

// TODO: move to Flow types
// InteractiveCheckbox.propTypes = {
//   fieldName: PropTypes.string.isRequired,
//   icon: PropTypes.any.isRequired,
//   title: PropTypes.string.isRequired,
//   description: PropTypes.string.isRequired
// };

export default InteractiveCheckbox;
